import React from 'react';
import GoalSections from '../Sections/Goals';
import Navigator from '../UI/Navigator';

const Goals = () => (
  <Navigator>
    <GoalSections />
  </Navigator>
);

export default Goals;
